












































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";

import { mapGetters } from "vuex";
interface newRow {
        item:string,
        itemType:string,
        itemDetail:string,
        payableBase:number | string | null,
        payableBaseDeduction: number | string | null,
        billingBasis:  number | string | null,
        levyNormal: number | string | null,
        deduction: number | string | null,
        levyProportion:number,
        currentNeedPay:  number | string | null,
        deductionFee:  number | string | null,
        codeDeduction:  number | string | null,
        currentFeePaid:  number | string | null,
        finalNeedPay:  number | string | null,
}
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
    },
})
export default class Rubbish extends Vue {
    tax: any = {};
    stampTaxList: any = [];
    newRow:newRow = {
        item:"建设行政事业性收费收入",
        itemType:"城镇垃圾处理费",
        itemDetail:"",
        payableBase:null,
        payableBaseDeduction:null,
        billingBasis: null,
        levyNormal:null,
        deduction:null,
        levyProportion:1,
        currentNeedPay: null,
        deductionFee: null,
        codeDeduction: null,
        currentFeePaid: null,
        finalNeedPay: null,
    };
    ljList = [
        {name:"城镇垃圾处理费--人1元",num:"1"},
        {name:"城镇垃圾处理费--人2元",num:"2"},
        {name:"城镇垃圾处理费--人3元",num:"3"},
        {name:"城镇垃圾处理费--人4元",num:"4"},
        {name:"城镇垃圾处理费--人5元",num:"5"},
        {name:"城镇垃圾处理费--人84元",num:"84"},
        {name:"城镇垃圾处理费--平方米2元",num:"2"},
        {name:"城镇垃圾处理费--其他0.06%",num:"0.0006"},
        {name:"城镇垃圾处理费--建筑、零售、住宿和餐饮、租赁和商务服务、文化、体育和娱乐业（0.03%）",num:"0.0003"},
        {name:"城镇垃圾处理费--每平方1元",num:"1"},
        {name:"城镇垃圾处理费--每人每季3元",num:"3"},
        {name:"城镇垃圾处理费--小商超每平方米每季1.8元",num:"1.8"},
        {name:"城镇垃圾处理费--小商超每平方米每月0.6元",num:"0.6"},
        {name:"城镇垃圾处理费--每平方每季1.2元",num:"1.2"},
        {name:"城镇垃圾处理费--餐饮业每平方米每季4.5元",num:"4.5"},
        {name:"城镇垃圾处理费--建筑零售住宿和餐饮租赁和商务服务文化体育和娱乐业（0.025%)",num:"0.00025"},
        {name:"城镇垃圾处理费--建筑零售等0.03%",num:"	0.0003"},
        {name:"城镇垃圾处理费--生活垃圾处理费（45元/吨）",num:"45"},
        {name:"城镇垃圾处理费--机关企事业每人每月2元",num:"2"},

    ]
    mainBodyList = [
        {id:1,name: "增值税小规模纳税人"},
        {id:2,name: "小型微利企业（增值税一般纳税人）"},
        {id:3,name: "个体工商户（增值税一般纳税人）"},
    ]
    taxTypes = [
        {id:19,name: "买卖合同"},
        {id:20,name: "承揽合同"},
        {id:21,name: "建设工程合同"},
        {id:22,name: "运输合同"},
        {id:2, name:"技术合同"},
        {id:23,name: "租赁合同"},
        {id:24,name: "保管合同"},
        {id:25,name: "仓储合同"},
        {id:13,name: "产权转移书据"},
        {id:8, name:"借款合同"},
        {id:26,name: "融资租赁合同"},
        {id:9, name:"财产保险合同"},
        {id:27,name: "营业账簿"},
        {id:1, name:"购销合同"},
        {id:3, name:"货物运输合同"},
        {id:4, name:"加工承揽合同"},
        {id:5, name:"仓储保管合同"},
        {id:6, name:"财产租赁合同"},
        {id:7, name:"建筑安装承包合同"},
        {id:10,name: "财产转移书据"},
        {id:11,name: "资金账簿"},
        {id:12,name: "权力许可证照"},
        {id:14,name: "建设工程勘察设计合同"},
        {id:15,name: "建筑安装工程承包合同"},
        {id:16,name: "其他营业账簿"},
        {id:17,name: "利息收入"},
        {id:18,name: "其他凭证"},
    ];
    period: string = "";
    time: string = "";
    getMonth(){
        let data = this.$store.state.accountBook.taxFormDto.taxInfoMap
        Object.keys(data).forEach((attr) => {
            if(attr === "城镇垃圾处理费"){
              if(data[attr].taxInfoMethod === 1) return false
              else return true
            }

		});
    }
    mounted() {
        this.getMonth()
    }
    // 切换纳税申报表
    changeType(val: number) {
        if (val === 1) this.fetchData();
        else this.$router.push({ path: "/declaration" });
    }
    init(){
            this.newRow = {
                item:"建设行政事业性收费收入",
                itemType:"城镇垃圾处理费",
                itemDetail:"",
                payableBase:null,
                payableBaseDeduction:null,
                billingBasis: null,
                levyNormal:null,
                deduction:null,
                levyProportion:1,
                currentNeedPay: null,
                deductionFee: null,
                codeDeduction: null,
                currentFeePaid: null,
                finalNeedPay: null,
            };
    }
    // 选择时间
    changeDate(start: string, end: string) {
        let data = this.$store.state.accountBook.taxFormDto.taxInfoMap
        Object.keys(data).forEach((attr) => {
            if(attr === "城镇垃圾处理费"){
              if(data[attr].taxInfoMethod === 1) {
                this.period =start
              }
              else {
                this.period =end
              }
            }

		});
        this.init()
        this.fetchData();
    }
    timeout = null;
    querySearchAsync(queryString: string, cb: Function) {
        let restaurants = this.ljList;
        cb(restaurants);

    }
    //   createStateFilter(queryString:string) {
    //     let state = this.newRow.payableBaseDeduction
    //     return (state:any) => {
    //       return (state.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //     };
    //   }
      handleSelect(item:any) {
        for(let i = 0;i<this.ljList.length;i++){
            if(this.ljList[i].name === item){
              this.newRow.levyNormal =  +this.ljList[i].num
            }
        }
        if (
            (this.newRow.payableBase != null) &&
            (this.newRow.levyNormal != null)
        ) {
            this.changeRow();
        }else { this.$message.warning("亲，请填写完整数据！");}
      }
       changeSelect(row:any) {
        for(let i = 0;i<this.ljList.length;i++){
            if(this.ljList[i].name === row.itemDetail){
              row.levyNormal =  +this.ljList[i].num
            }
        }
        this.$nextTick(()=>{
            this.changeRow();

        })
      }
    fetchData() {
        Vue.axios
            .get(
                `rubbish/fee?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`
            )
            .then((res) => {
                this.tax = res.data
                this.stampTaxList = res.data.rubbishFeeRowDtoList;
                this.time =
                    this.tax.startPeriod.substring(0, 4) +
                    "年" +
                    this.tax.startPeriod.substring(4) +
                    "月" +
                    "至" +
                    this.tax.endPeriod.substring(0, 4) +
                    "年" +
                    this.tax.endPeriod.substring(4) +
                    "月";
            });
    }
    changeRow() {
        // this.tax.stampTaxList.forEach((e: any) => {
        //     e.type = e.type.id;
        // });
        Vue.axios
            .post(
                `rubbish/fee`,
                this.tax
            )
            .then((res) => {
                this.fetchData();
            });
    }
    addRow() {
        if (
            (this.newRow.payableBase != null) &&
            (this.newRow.levyNormal != null)
        ) {
            this.stampTaxList.push(this.newRow);
            this.init()
            this.tax.rubbishFeeRowDtoList = this.stampTaxList;
            this.changeRow();
        } else {
            this.$message.warning("亲，请填写完整数据！");
        }
    }
    remove(index: number) {
        if (this.tax.rubbishFeeRowDtoList.length === 1) {
            this.tax.rubbishFeeRowDtoList = [];
        } else {
            this.tax.rubbishFeeRowDtoList.splice(index, 1);
        }
        this.changeRow();
    }
}
